export const DECREMENT_MAIN_COUNTER = 'DECREMENT_MAIN_COUNTER'
export const INCREMENT_MAIN_COUNTER = 'INCREMENT_MAIN_COUNTER'

// Language
export const UPDATE_LOCALE = 'UPDATE_LOCALE'

// Filters
export const UPDATE_SEARCH = 'UPDATE_SEARCH'
export const ADD_GROUP = 'ADD_GROUP'
export const REMOVE_GROUP = 'REMOVE_GROUP'

// Game
export const UPDATE_GAME_STATE = 'UPDATE_GAME_STATE'

// Configuration
export const TOGGLE_DEBUG = 'TOGGLE_DEBUG'
export const TOGGLE_SIMPLE_VIEW = 'TOGGLE_SIMPLE_VIEW'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js